function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 2.59v11.02l-9.35 6.54c-.85-1.01-.9-2.54.05-4.25l3.12-5.61L8.76 5c.89-1.6 2.06-2.41 3.24-2.41z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".6",
  d: "M21.35 20.15c-.65.79-1.78 1.26-3.29 1.26H5.94c-1.51 0-2.64-.47-3.29-1.26L12 13.61l9.35 6.54z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M21.35 20.15L12 13.61V2.59c1.18 0 2.35.81 3.24 2.41l2.94 5.29 3.12 5.61c.95 1.71.9 3.24.05 4.25z"
})));